import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import TickIcon from '@clearscore/rainbow.icons.success-inline';
import WarningIcon from '@clearscore/rainbow.icons.warning-inline';
import ErrorIcon from '@clearscore/rainbow.icons.error-inline';
import Text from '@clearscore/rainbow.text';
import toTitleCase from '@clearscore/normalize.title-case';

import styles from './criteria.css';
import { themes, types } from './constants';

const getIcon = ({ type }) =>
    ({
        [types.SUCCESS]: TickIcon,
        [types.WARNING]: WarningIcon,
        [types.ERROR]: ErrorIcon,
    }[type]);

const Criteria = ({ children, theme, type, dataId }) => {
    const Icon = getIcon({ type });
    const themeClass = styles[`isTheme${toTitleCase(theme)}`];
    const typeClass = styles[`isType${toTitleCase(type)}`];

    return (
        <div
            data-id={dataId}
            data-qa="criteria"
            className={cx(styles.component, themeClass, {
                [styles.isVisible]: !!children,
            })}
        >
            <span className={cx(styles.icon, typeClass)}>
                <Icon width={14} height={14} />
            </span>
            <Text.Caption>{children}</Text.Caption>
        </div>
    );
};

Criteria.themes = themes;
Criteria.types = types;

Criteria.propTypes = {
    children: PropTypes.string,
    theme: PropTypes.oneOf(Object.values(themes)),
    type: PropTypes.oneOf(Object.values(types)).isRequired,
    dataId: PropTypes.string,
};

Criteria.defaultProps = {
    children: '',
    dataId: '',
    theme: themes.LIGHT,
};

export default Criteria;
